<template>
  <v-data-table
    :headers="[
      {
        text: 'Teste SAMP',
        value: 'teste_samp'
      },
      {
        text: 'Erros Críticos',
        value: 'erros_criticos',
        align: 'center'
      },
      {
        text: 'Não Críticos',
        value: 'erros_nao_criticos',
        align: 'center'
      },
      {
        text: 'Exceções',
        value: 'excecoes',
        align: 'center'
      },
      {
        text: 'Análises Futuras',
        value: 'analises_futuras',
        align: 'center'
      }
    ]"
    :items="errosSamp"
    :loading="loading"
    :hide-default-header="loading"
    hide-default-footer
    disable-pagination
  >
    <template v-slot:[`item.teste_samp`]="{ item }">
      <span :style="{ color: getCorLinha(item) }">{{ item.teste_samp }}</span>
    </template>
    <template v-slot:[`item.erros_criticos`]="{ item }">
      <span :style="{ color: getCorLinha(item) }">{{ item.erros_criticos | parseNumberToIntegerBR }}</span>
    </template>
    <template v-slot:[`item.erros_nao_criticos`]="{ item }">
      <span :style="{ color: getCorLinha(item) }">{{ item.erros_nao_criticos | parseNumberToIntegerBR }}</span>
    </template>
    <template v-slot:[`item.excecoes`]="{ item }">
      <span :style="{ color: getCorLinha(item) }">{{ item.excecoes | parseNumberToIntegerBR }}</span>
    </template>
    <template v-slot:[`item.analises_futuras`]="{ item }">
      <span :style="{ color: getCorLinha(item) }">{{ item.analises_futuras | parseNumberToIntegerBR }}</span>
    </template>
  </v-data-table>
</template>

<script>
  import IqBdgdService from '@/services/IqBdgdService';

  export default {
    name: 'ResumoErrosSamp',
    props: {
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      errosSamp: []
    }),
    mounted() {
      this.getErrosSamp();
    },
    methods: {
      getErrosSamp() {
        if (!(this.bdgdVersao && this.bdgdVersao.id)) return false;
        this.loading = true;
        IqBdgdService.getIebAnalitico(this.bdgdVersao.id)
          .then((response) => {
            this.errosSamp = response.data;
            this.$emit('status', this.getStatusGeral());
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao buscar os dados analíticos do IEB.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      getCorLinha(item) {
        if (Number(item.erros_criticos) > 0) return this.$vuetify.theme.themes.light.error;
        if (Number(item.erros_nao_criticos) > 0) return '#ffb000';
        if (Number(item.analises_futuras) > 0) return this.$vuetify.theme.themes.light.warning;
        if (Number(item.excecoes) > 0) return this.$vuetify.theme.themes.light.success;
        return this.$vuetify.theme.themes.light.success;
      },
      getStatusGeral() {
        if (this.errosSamp.some((i) => Number(i.erros_criticos) > 0)) return 'ERRO_CRITICO';
        if (this.errosSamp.some((i) => Number(i.erros_nao_criticos) > 0)) return 'ERRO_NAO_CRITICO';
        if (this.errosSamp.some((i) => Number(i.analises_futuras) > 0)) return 'ANALISE_FUTURA';
        if (this.errosSamp.some((i) => Number(i.excecoes) > 0)) return 'EXCECAO';
        return 'SUCESSO';
      }
    },
    watch: {
      bdgdVersao() {
        this.getErrosSamp();
      }
    }
  };
</script>
